import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, ReplaySubject, Subscription } from "rxjs";
import { TitleCasePipe } from "@angular/common";
import { Subject } from "rxjs/Subject";
import { RangeDateItinerary } from "./interfaz/rangeDateItinerary";
import { RestService } from "./rest.service";
import { environment } from "../../environments/environment";
import { ApiService } from "../itinerary/shared/api.service";
import { Logger } from "../core/logger.service";
import { Router,NavigationExtras, NavigationEnd, NavigationStart } from "@angular/router";
import * as moment from "moment";
import { ItemSelected } from "./interfaz/itemSelected";
import { DatePipe } from "@angular/common";
import { UserService } from "../pages/com.usblick.common/auth/user.service";
import { CookieService } from "ngx-cookie";
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import {setting} from '../../../setting';
import { MaterialModalConfirmComponent } from "./material-modal-confirm/material-modal-confirm.component";
import { MaterialModalAlertComponent } from "../shared/material-modal-alert/material-modal-alert.component";
import { map } from "rxjs/operators";
import { NotificationService } from "./notifications/notification.service";

@Injectable()
export class ItineraryService {
  itinerary: any = {};
  itineraryId: any;
  itineraryPartial: Array<any> = [];
  loading = false;
  load = false;
  paymentConditionName: any;
  paymentConditionIcono: any;

  activeItinerarySubject = new BehaviorSubject<any>(null); // Almacena el valor actual
  activeItinerary = this.activeItinerarySubject.asObservable(); // Expone como Observable


  itineraryArrivalDate: any;
  itineraryDepartureDate: any;

  //objeto observable que usa el mapa para sincronizar cambios en los datos de los destinos
  objectMap: Observable<any>;
  objectMapSubject: Subject<any>;

  //objeto observable que usa loading
  loadingObject: Observable<boolean>;
  loadingObjectSubject: Subject<boolean>;

  //objeto observable que usa el item seleccionado de multidestino para accionar a cambios
  itemSelectedMultidestination: Observable<ItemSelected>;
  itemSelectedMultidestinationSubject: Subject<ItemSelected>;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  payload: Observable<any>;
  payloadSubject: Subject<any>;

  flight: Observable<any>;
  flightSubject: Subject<any>;

  paymentConditions: any;

  public paymentUpdatebalanceSubject = new Subject<any>();
  public paymentUpdatebalance = this.paymentUpdatebalanceSubject.asObservable();

  dateCatchSelect$:BehaviorSubject<any> = new BehaviorSubject('');
  titleHotelUnique$:BehaviorSubject<any> = new BehaviorSubject('');
  lastItemHotel$:BehaviorSubject<any> = new BehaviorSubject('');
  lastItemHotelService$:BehaviorSubject<any> = new BehaviorSubject('');
  valueCatchBoolean$:BehaviorSubject<boolean> = new BehaviorSubject(false);
  valueUltimateDate$:BehaviorSubject<any> = new BehaviorSubject('');
  booleanModalActive$:BehaviorSubject<boolean> = new BehaviorSubject(true);
  deleteItem: BehaviorSubject<any> = new BehaviorSubject(true);
  currencySuccessEmit:BehaviorSubject<any> = new BehaviorSubject('');
  currencyRemoveEmit: BehaviorSubject<any> = new BehaviorSubject('');
  private modalClosedSubject = new Subject<boolean>();
  modalClosed$ = this.modalClosedSubject.asObservable();

  private emitUpdateItineraryPaymentModal = new Subject<void>();
  emitUpdateItineraryPaymentModal$ = this.emitUpdateItineraryPaymentModal.asObservable();

  private noCloneOneWaySubject = new Subject<boolean>();
  noCloneOneWay$ = this.noCloneOneWaySubject.asObservable();

   private booleanValidateByStatus = new Subject<boolean>();
  booleanValidateByStatus$ = this.booleanValidateByStatus.asObservable();

private noCloneVehicleDoubleWaySource = new Subject<void>();
noCloneVehicleDoubleWay$ = this.noCloneVehicleDoubleWaySource.asObservable();

private backupVehicles: Map<number, any[]> = new Map();

private downloadItineraryInit: boolean = false;
private downloadLiquidationInit: boolean = false;
private downloadVoucherInit: boolean = false;

setBackupResults(results: any[]): void {
  if (results && Array.isArray(results)) {
    this.backupVehicles.clear(); // Limpiar backup anterior

    results.forEach((group, index) => {
      if (group.vehicles && Array.isArray(group.vehicles)) {
        // Guardar solo los vehicles de cada grupo
        this.backupVehicles.set(index, JSON.parse(JSON.stringify(group.vehicles)));
      }
    });
  }
}

getBackupResults(): Map<number, any[]> {
  return new Map(this.backupVehicles); // Devolver copia del Map
}

hasBackupResults(): boolean {
  return this.backupVehicles.size > 0;
}

// Método para restaurar vehicles a un resultado específico
restoreVehiclesToResults(results: any[]): any[] {
  if (!results || !Array.isArray(results)) return results;



  return results.map((group, index) => {
    if (this.backupVehicles.has(index)) {
      const backupVehicles = this.backupVehicles.get(index);

      // Crear nueva copia del grupo manteniendo todas las propiedades
      return {
        ...group, // Mantener todas las propiedades existentes
        vehicles: JSON.parse(JSON.stringify(backupVehicles)) // Restaurar solo los vehicles
      };
    }
    return group; // Si no hay backup, devolver el grupo original
  });
}

emitNoCloneVehicleDoubleWay(): void {
  this.noCloneVehicleDoubleWaySource.next();
}

  notifyModalClosed(edit: boolean) {
    this.modalClosedSubject.next(edit);
  }

  modifiedNoCloneOneWay(clone: boolean) {
    this.noCloneOneWaySubject.next(clone);
  }

  itineraries: Observable<any>;
  itineraryItems: any = [];
  itinerariesSubject: Subject<any>;
  _activePages = 1;
  partialReserve = false; // temporal
  resultReserve: any = [];
  paxesInItems: Array<{
    idPax: any;
    itemId: string;
    document_number: string;
    first_name: string;
    last_name: string;
    email: string;
    country: string;
    birth_date: string;
    title: string;
    identificationType: string;
    state: string;
    phone: string;
    phone2: string;
    city: string;
    address: string;
    postal_code: string;
  }> = [];
  private clients: string;
  private postClient: string;
  private urlActiveItinerary: string;
  private urlUsb =setting.apiBookingUrl;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  itinerayDetailAux: any = {};

  itinerary$ = new BehaviorSubject<any>(null);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  parcialTotalPrice: any;
  parcialBlickoins: any;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public logger: Logger;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  form: any;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  origin: any;

  private emitUpdateCardsSource = new Subject<boolean>();
  emitUpdateCards$ = this.emitUpdateCardsSource.asObservable();

private selectedInsurancesSubject = new BehaviorSubject<any[]>([]);
selectedInsurances$ = this.selectedInsurancesSubject.asObservable();


  constructor(
    public _restService: RestService,
    private apiService: ApiService,
    private http: HttpClient,
    private dialog: MatDialog,
    private _router: Router,
    private titleCasePipe: TitleCasePipe,
    private datePipe: DatePipe,
    public userService: UserService,
    private _cookieService: CookieService,
    private ngSpinner: NgxSpinnerService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<MaterialModalConfirmComponent>,

  ) {
    this.logger = new Logger();
    this.clients = this.urlUsb + "/clients?name=";
    this.postClient = this.urlUsb + "/clients";
    this.urlActiveItinerary = this.urlUsb + "/itineraries";
    this.flightSubject = new Subject<any>();
    this.flight = this.flightSubject.asObservable();
    this.payloadSubject = new Subject<any>();
    this.payload = this.payloadSubject.asObservable();
    this.activeItinerarySubject = new BehaviorSubject<any>([]);
    this.itinerariesSubject = new Subject<any>();
    this.objectMapSubject = new Subject<any>();
    this.loadingObjectSubject = new Subject<boolean>();
    this.activeItinerary = this.activeItinerarySubject.asObservable();
    this.itineraries = this.itinerariesSubject.asObservable();
    this.objectMap = this.objectMapSubject.asObservable();
    this.loadingObject = this.loadingObjectSubject.asObservable();
    this.itemSelectedMultidestinationSubject = new Subject<any>();
    this.itemSelectedMultidestination = this.itemSelectedMultidestinationSubject.asObservable();
    this.setupRouteChangeListener();

  }

  private setupRouteChangeListener() {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.parcialTotalPrice = 0;
        this.parcialBlickoins = 0;
        // console.log(this.parcialBlickoins);
        // console.log(this.parcialTotalPrice)
      }
    });


  }

  emitUpdateCards(reserve: boolean) {
    this.emitUpdateCardsSource.next(reserve);
  }

  /**
   *
   */
  storage() {
    let credentials = localStorage;
    if (sessionStorage.getItem("credentials") != null) {
      credentials = sessionStorage;
    }
    return credentials;
  }

  /**
   *
   */
  getItemSelectedMultidestination(): Observable<any> {
    return this.itemSelectedMultidestinationSubject.asObservable();
  }
  /**
   *
   */
  getObjectMap(): Observable<any> {
    return this.objectMapSubject.asObservable();
  }

  /**
   *
   */
  getLoadingObject(): Observable<boolean> {
    return this.loadingObjectSubject.asObservable();
  }

  /**
   *
   */
  getActiveItinerary(): Observable<any> {
    return this.activeItinerarySubject.asObservable();
  }
  /**
   *
   * @param id
   */
  select(id: any) {
    this._restService.doGet("app", "itineraries/" + id).subscribe(
      (response: any) => {
        this.itinerary = response.data;
        //this.itinerary =  this.userService.itineraryActive[0];
      },
      (error) => {
        console.log("Select-Error: " + error);
      }
    );
  }
  /**
   *
   * @param skip
   */
  createItineraryNew(skip?) {
    let validate = this.itemEmpty();
    if (skip) {
      if (validate) {
        this.save("skip");
        return false;
      }
    } else {
      if (validate) {
        this.save("save");
      }
    }
  }
  /**
   *
   */
  private createItinerary() {
    let uid = Math.round(new Date().getTime() / 1000.0);
    let itinerary = {
      id: "",
      uid: uid,
      agent_id: 1,
      client_id: 1,
      status_id: 1,
      location: "",
      origin: "",
      destination: [],
      arrivalDate: new Date(),
      departureDate: new Date(),
      status: "Draft",
      active: true,
      title: "",
      items: [],
    };
    let validateItinerary = this.validateItinerary();
    if (validateItinerary === null) {
      this.itinerary = itinerary;
    }
  }
  /**
   *
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  validateItinerary(): void {
    // eslint-disable-next-line valid-typeof
    if (typeof this.itinerary["active"] !== undefined) {
      return this.itinerary["uid"];
    }
    return null;
  }
  /**
   *
   * @param uid
   * @param type
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  validateSave(uid: any, type: any) {
    if (typeof this.itinerary !== undefined && this.itinerary.uid == uid) {
      if (this.itinerary["status"] == "Saved") {
        return true;
      }
    }
    return null;
  }

  /**
   *
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  itemEmpty() {
    if (typeof this.itinerary.items !== undefined) {
      if (this.itinerary.items.length > 0) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * @param type
   * @param noCreateItinerary
   * @param title
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  save(type: any, noCreateItinerary?, title?) {
    let validate = this.itemEmpty();
    if (validate) {
      if (this.itinerary != null) {
        if (title != null) {
          this.itinerary.title = title;
        }
        this._restService.doPost("app", "itineraries", this.itinerary).subscribe(
          (response: any) => {
            this.itinerary.id = response.id;
            if (type == "skip") {
              this.itinerary = {};
            }
            if (this.itinerary["status"] != "Saved") {
              if (type == "skip") {
                this.itinerary = {};
              } else {
                this.itinerary["active"] = false;
                this.itinerary["status"] = "Saved";
              }
              if (noCreateItinerary) {
                return false;
              }
            } else {
              this.itinerary["active"] = false;
              this.itinerary["status"] = "Saved";
            }
            this.createItinerary();
          },
          (error) => {
            console.log("Save-Error: " + error);
          }
        );
      }
    }
  }

  /**
   *
   * @param item
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  add(item: any): Observable<any> {

    // console.log(item)
    let product;
    let validateDate = false;
    const message = '';

    /*const index = this._validateItem(item.id); // //comentado yovanny 150923
    if (item.payloadUpdate !== undefined && item.payloadUpdate.products[0] !== undefined) {
      product = item.payloadUpdate.products[0];
      this.itinerary.origin = product.origin;
      validateDate = this._validateDate(product.arrivalDate, product.departureDate);
      item.qty = product.qtyProduct;
    }
  */
    // console.log("agregar el item al itinerario push 1", item);

  // if (index == -1 || validateDate == false) { //comentado yovanny 150923
      if (this.itinerary === null) {
        this.createItinerary();
      }

   /*   for (const i in this.itinerary.items) {  //comentado yovanny 150923
        if (
          this.itinerary.items[i].arrivalDate == item.arrivalDate &&
          this.itinerary.items[i].departureDate == item.departureDate &&
           this.itinerary.items[i].id == item.id
        ) {
          return Observable.of(this.getMessageItemDuplicate(this.itinerary.items[i].categoryName));
        }
      }*/
      // console.log("agregar el item al itinerario push 2", item);
      if (this.itinerary.items === undefined) {
        return Observable.of("It is necessary to create an itinerary");
      }

      // console.log("agregar el item al itinerario push 3", item);

      this.itinerary.items.push(item);
      this.itinerary.status = 'Quote';
      // this.updateItinerary(this.itinerary);

      this.sendMessageSubscriptorItemSelected(item.destination, item.categoryName, this.itinerary);
      return Observable.of(this.itinerary);
  /*  } else {
      return Observable.of("Cannot add this item to itinerary");
    } */
  }

  /**
   *
   * @param categoryName
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  getMessageItemDuplicate(categoryName: string) {
    let message;
    switch (categoryName) {
      case "TRANSPORTS": {
        message = "Cannot add the same transport at the same date";
        break;
      }
      case "TOURS":
        message = "Cannot add the same tours at the same date";
        break;
      case "CRUISES":
        message = "Cannot add the same cruise at the same date";
        break;
      case "PTHEMES":
        message = "Cannot add the same park theme at the same date";
        break;
      case "INSURANCE":
        message = "Cannot add the same insurance at the same date";
        break;
      default:
        message = "Cannot add the same room at the same date";
        break;
    }
    return message;
  }

  /**
   *
   * @param _item
   * @param old
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  updateDisneyItem(_item: any, old: any) {
    if (this.itinerary !== undefined && this.itinerary !== null) {
      this.remove(old);
      this.itinerary["items"].push(_item);
    }
    if (this.itinerary["status"] == "Saved") {
      this.updateItinerary(this.itinerary);
    }
  }

  /**
   *
   * @param item
   * @param update
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  remove(item: any, update?: any) {
    this.deleteItem.next(false);
    let exist = 0;
    this.itinerary = this.userService.itineraryActive[0];

    this.itinerary.items.forEach((element) => {
      if (item.id != element.id) {
        const itemDestination = item.destination?.iata_code || item?.item?.destination.iata_code || null;
        //veo cuales son los productos distintos al que borre
        if (element.destination.iata_code == itemDestination) {
          //si de los otros productos alguno tiene el mismo codigo iata digo que si existe
          exist++;
        }
      }
    });

    //si existen mas productos ademas del que borre con el mismo codigo iata
    if (exist > 0) {
      // aqui se deberia de actualizar destination con el producto que quedo
    } else {
      //si no existen mas productos con el mismo codigo iata del producto que borre.
      let destinyFound = this.itinerary.destination.find((element) => element.iata_code == item.destination.iata_code);
      if (destinyFound) {
        let index = this.itinerary.destination.indexOf(destinyFound);
        this.itinerary.destination.splice(index, 1);

      }
    }

    this.sendMessageSubscriptorLoading(true);

    let validate = this.itemEmpty();
    const index = this._validateItem(item.id);  //idProduct

    if (validate && index > -1) {
      if (this.itinerary["status_id"] != 6) {
        //if ((this.itinerary['status_id'] == 1) || (this.itinerary['status_id'] == 2)) {
        this._restService
          .doDelete(
            "app",
            "products/" +
              encodeURIComponent(item.categoryName != "DISNEY" ? item.id : item.itemInfo.id) +
              "?itinerary_id=" +
              this.itinerary.id
          )
          .subscribe(
            (response: any) => {

              this.itinerary.items.splice(index, 1);

              if (update !== null && update !== undefined) {
                this.add(update);
                // this._router.navigate(['/results']);
              } else {
                const clientData = JSON.parse(localStorage.getItem(setting.name));
                this.itinerary.clientId = clientData.id;
                this.updateItinerary(this.itinerary);
                this.sendMessageSubscriptorItemSelected(item.destination, item.categoryName, this.itinerary, true);


              }
              this.notificationService.success("¡Felicitaciones! Producto eliminado con éxito.");
              setTimeout(() => {
                this.deleteItem.next(true);
              }, 1200);
           //   isDelete = true;
            },
            (error) => {
              this.notificationService.error("Error !!", "There's been a problem");
              setTimeout(() => {
                this.deleteItem.next(true);
              }, 1200);
           //   isDelete = false;
            }
          );
      } else {
        this.notificationService.error("Error, You cannot delete a product with a status other than saved.", " fun!");
      }
      this.sendMessageSubscriptorLoading(false);
    }

    setTimeout(() => {
      this.userService.itineraryUpdateProductsTotalPrices(this.userService.itineraryActive[0].id);

   }, 500);
  }

  /**
   * Removes an item and returns an Observable that completes when done.
   * Use this for sequential deletions to ensure each deletion completes before the next.
   * @param skipUpdateItinerary - if true, skips the updateItinerary call (for batch deletions)
   */
  remove$(item: any, update?: any, skipUpdateItinerary: boolean = false): Observable<any> {
    return new Observable(observer => {
      this.deleteItem.next(false);
      let exist = 0;
      this.itinerary = this.userService.itineraryActive[0];

      this.itinerary.items.forEach((element) => {
        if (item.id != element.id) {
          const itemDestination = item.destination?.iata_code || item?.item?.destination.iata_code || null;
          if (element.destination.iata_code == itemDestination) {
            exist++;
          }
        }
      });

      if (exist > 0) {
        // nothing special needed
      } else {
        let destinyFound = this.itinerary.destination.find((element) => element.iata_code == item.destination.iata_code);
        if (destinyFound) {
          let index = this.itinerary.destination.indexOf(destinyFound);
          this.itinerary.destination.splice(index, 1);
        }
      }

      this.sendMessageSubscriptorLoading(true);

      let validate = this.itemEmpty();
      const index = this._validateItem(item.id);


      if (validate && index > -1) {
        if (this.itinerary["status_id"] != 6) {
          const deleteUrl = "products/" +
            encodeURIComponent(item.categoryName != "DISNEY" ? item.id : item.itemInfo.id) +
            "?itinerary_id=" + this.itinerary.id;

          this._restService.doDelete('booking', deleteUrl).subscribe(
            (response: any) => {
              this.itinerary.items.splice(index, 1);

              if (update !== null && update !== undefined) {
                this.add(update);
              } else {
                const clientData = JSON.parse(localStorage.getItem(setting.name));
                this.itinerary.clientId = clientData.id;
                // Only call updateItinerary if not skipped (for batch deletions)
                if (!skipUpdateItinerary) {
                  this.updateItinerary(this.itinerary);
                }
                this.sendMessageSubscriptorItemSelected(item.destination, item.categoryName, this.itinerary, true);
              }
              this.notificationService.success("¡Felicitaciones! Producto eliminado con éxito.");
              this.sendMessageSubscriptorLoading(false);
              this.userService.itineraryUpdateProductsTotalPrices(this.userService.itineraryActive[0].id);
              observer.next(response);
              observer.complete();
            },
            (error) => {
              this.notificationService.error("Error !!", "There's been a problem");
              this.sendMessageSubscriptorLoading(false);
              observer.error(error);
            }
          );
        } else {
          this.notificationService.error("Error, You cannot delete a product with a status other than saved.", " fun!");
          this.sendMessageSubscriptorLoading(false);
          observer.complete();
        }
      } else {
        observer.complete();
      }
    });
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  createReservation(roomSelect: any,  itinerary , paxesInItems): any {

    this.itineraryId = itinerary.id;
    this.resultReserve = [];
    this.resultReserve.push({
      itinerary_id: this.itineraryId,
      starDate: moment(),
      endDate: moment(),
      status_id: 4,
      qtyReservedProduct: 0,
      totalNetPrice: 0,
    });

    this.paxesInItems = paxesInItems;
    const paxesFilter = this.paxesInItems.filter((val) => val.itemId == roomSelect.id);
    if (roomSelect.categoryName === 'TOUR') {
        for (let i = 0; i < paxesFilter.length; i++) {
          const idPax = (document.getElementById("idPax-" + paxesFilter[i].idPax) as HTMLInputElement).value;
          const document_number = "document_number-" + paxesFilter[i].idPax;
          const email = "email-" + paxesFilter[i].idPax;
          const country = "country-" + paxesFilter[i].idPax;
          if (paxesFilter[i].idPax === idPax) {
            paxesFilter[i].document_number = (document.getElementById(document_number) as HTMLInputElement).value;
            paxesFilter[i].email = (document.getElementById(email) as HTMLInputElement).value;
            paxesFilter[i].country = (document.getElementById(country) as HTMLInputElement).value;
          }
        }
    }

      const paxes = this.getPaxesInfo(paxesFilter);
      const _payload = this._payload(roomSelect, paxes);
      this.makeReserve(_payload, roomSelect, paxes);
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  makeReserve(payload: any, item: any, paxes: any) {
    this._restService.doPost("api", "/reservation", payload).subscribe(
      (response: any) => {
        if (response[0] !== null && response[0].result !== null && response[0].status !== false) {
          //guardar en variable los resultados
          if (localStorage.getItem("nrPayment")) {
            response[0].result.currency = this.userService?.itineraryActive[0]?.currency;
            this.postMainTransaction(response[0].result);
          }

          if (item.categoryName == "HOTELS") {
            this.resultReserve.push({
              status_id: response[0].status === true ? 2 : 0,
              resultReserve: response[0].status === true ? response[0].result : response[0].message,
              category_id: item.category_id,
              providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId,
              netPrice: item.optionNightsNetTotal,
              totalPrice: item.optionNightsNetTotalProf,
              paxList: this.setPaxesReserve(paxes),
              uid: item.id,
              percentage: item.percentage,
            });
          } else if (item.categoryName == "TOURS") {
            this.resultReserve.push({
              status_id: response[0].status === true ? 2 : 0,
              resultReserve: response[0].status === true ? response[0].result : response[0].message,
              category_id: item.category_id,
              providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId,
              netPrice: item.totalPrice,
              totalPrice: item.totalPriceProf,
              paxList: this.setPaxesReserve(paxes),
              uid: item.id,
              percentage: item.percentage,
            });
          } else {
            this.resultReserve.push({
              status_id: response[0].status === true ? 2 : 0,
              resultReserve: response[0].status === true ? response[0].result : response[0].message,
              category_id: item.category_id,
              providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId,
              // netPrice: (response[0].status===true) ? item.totalPrice : 0,
              netPrice: item.totalPrice ? item.totalPrice : 0,
              paxList: this.setPaxesReserve(paxes),
              uid: item.id,
              percentage: item.percentage,
            });
          }

          if (this.resultReserve.length - 1 >= this.itineraryItems.length) {
            //guardar en API

            this.saveReservation(this.resultReserve);
          } else {
            this.ngSpinner.hide();
          }
        } else {
          this.resultReserve.push({
            status_id: 4, // 4 Denied
            resultReserve: response.message,
            category_id: item.category_id,
            netPrice: item.totalPrice,
            providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId,
            paxList: this.setPaxesReserve(paxes),
            uid: item.id,
          });

          if (this.resultReserve.length - 1 >= this.itineraryItems.length) {
            this.saveReservation(this.resultReserve);
          } else {
            this.ngSpinner.hide();
          }
        }
      },
      (error) => {
        this.resultReserve.push({
          status_id: 0,
          resultReserve: error,
          category_id: item.category_id,
          netPrice: item.totalPrice,
          paxList: this.setPaxesReserve(paxes),
          uid: item.id
        });
        if (this.resultReserve.length - 1 >= this.itineraryItems.length) {
          this.saveReservation(this.resultReserve);
        } else {
          this.ngSpinner.hide();
        }
        console.log(error);
      }
    );



  }
  // eslint-disable-next-line @typescript-eslint/member-ordering
  cancelReservation(item: any): any {
    this.ngSpinner.show();
    const data: any = this.itinerary;
       this._restService.doPut("app", "products/cancelReservation/" + item.id + "/" + item.itinerary_id, data).subscribe(
      (response: any) => {
        if (response.success) {

          const dialogRef_ = this.dialog.open(MaterialModalAlertComponent, {
            height: "auto",
            width: "350px",
            data: response.res.message,
            disableClose: true,
          });

          dialogRef_.afterClosed().subscribe(result => {
            // console.log('valor que llega del modal', result);
            if(result){
              // location.reload();

            }
          });

          this.userService.updateProductsPrices(item.itinerary_id);
          this.ngSpinner.hide();
        }
        if (!response.success) {
          this.ngSpinner.hide();
          const dialogRef_ = this.dialog.open(MaterialModalAlertComponent, {
            height: "auto",
            width: "350px",
            data: response.message,
            disableClose: true,
          });
        }
        return response;
      },
      (error) => {
        this.ngSpinner.hide();
        console.log("Save-Error: " + error);
        return false;
      }
    );
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  /**
   * Cart-sidebar-specific cancellation flow. Mirrors what
   * `cancelReservation` is supposed to do but with the correct endpoint
   * and the right payload contract. This method is intentionally
   * separate from `cancelReservation` so we don't change the behaviour
   * of any other caller of the original method.
   *
   * Endpoint: `PUT /api/v1/products/cancelReservation/{itinerary_id}`
   *   (single param, NOT `/{itemId}/{itineraryId}` like the original).
   *
   * Body: `{ providerId, reservationLocator, productsId: [id, ...] }`
   *   For hotels, all sibling items sharing the same `reservationLocator`
   *   are sent together so the backend cancels the whole reservation in
   *   one shot.
   *
   * After a successful response (or `RESERVATION_CANCELED` which the
   * backend uses to mean "already cancelled"), the local itinerary is
   * mutated in place (cancelled items marked statusId=5) so the cart
   * sidebar re-renders without waiting for `updateItinerary` to
   * round-trip the backend.
   *
   * The caller is expected to have already shown a confirmation modal.
   */
  cancelReservationFromCart(item: any, onLocalMutationDone?: () => void): any {
    this.ngSpinner.show();

    const cancelData: any = this.buildCancelData(item);

    this._restService
      .doPut('app', `products/cancelReservation/${item.itinerary_id}`, cancelData)
      .subscribe(
        (response: any) => {

          // The backend can return `success: false` with the
          // `RESERVATION_CANCELED` code when the reservation was already
          // cancelled by a previous request (e.g. user retried, or the
          // cancellation was triggered from another tab). In that case the
          // cancellation is still effective on the backend, so we treat it
          // as a successful flow on the frontend: refresh local state.
          const isAlreadyCancelled =
            !response.success &&
            response?.res?.code_label_status === 'RESERVATION_CANCELED';

          if (response.success || isAlreadyCancelled) {
            this.userService.updateProductsPrices(item.itinerary_id);

            // Mark cancelled items with statusId=5 so the cart sidebar
            // re-renders them as cancelled (badge, price=0) without waiting
            // for the `updateItinerary` round-trip below.
            const itinerary = this.userService?.itineraryActive?.[0];
            if (itinerary && Array.isArray(itinerary.items)) {
              const cancelledIds = new Set<number>(
                (cancelData.productsId || []).map((id: any) => Number(id))
              );
              for (const item of itinerary.items) {
                if (cancelledIds.has(Number(item?.id))) {
                  item.statusId = 5;
                  item.status_id = 5;
                  item.status = 'Cancelado';
                  item.statusName = 'Cancelado';
                  if (Array.isArray(item.statusIds) && item.statusIds.length > 0) {
                    item.statusIds = item.statusIds.map((s: any) => ({
                      ...s,
                      statusId: 5,
                      statusName: 'Cancelado',
                    }));
                  }
                }
              }
              itinerary.clientId = itinerary.client_id;
              this.itinerary = itinerary;
            }

            // Notify the caller (cart sidebar) so it can force its own
            // change detection without depending on the parent's
            // distinctUntilChanged.
            if (typeof onLocalMutationDone === 'function') {
              onLocalMutationDone();
            }

            // Best-effort refresh of the active itinerary in the backend.
            // Same flow as `item-hotel.component.ts:520` in the
            // itinerary-summary view. If `client_id` is null on the
            // response, the cart sidebar already has the up-to-date
            // local state from the splice above.
            if (this.userService?.itineraryActive?.[0]) {
              this.updateItinerary(this.userService.itineraryActive[0], false);
            }

            this.ngSpinner.hide();
          }
          if (!response.success) {
            this.ngSpinner.hide();
          }
          return response;
        },
        (error) => {
          this.ngSpinner.hide();
          console.log('Save-Error: ' + error);
          return false;
        }
      );
  }

  /**
   * Build the body for `PUT /products/cancelReservation/{itinerary_id}`
   * following the same conventions used by the itinerary-summary item
   * components (`item-hotel.component.ts:483-507` and siblings).
   *
   * For hotels, when several rooms share the same `reservationLocator`,
   * the backend expects all of their ids in `productsId` so the whole
   * reservation is cancelled in a single request.
   */
  private buildCancelData(item: any): any {
    const categoryId = item?.category_id ?? item?.categoryId;
    const providerId = item?.providerId;
    const reservationLocator =
      item?.resultReserve?.reservation?.providerReservationId ??
      item?.resultReserve?.providerReservationId ??
      item?.resultReserve?.additionalInfo?.idReservation ??
      null;

    if (!item || !item.itinerary_id || !reservationLocator) {
      // Fallback: send only the current item id so the backend can
      // decide what to do (it will likely 400/404 with a clear error).
      return {
        providerId,
        reservationLocator,
        productsId: item?.id ? [item.id] : [],
      };
    }

    // For hotels, gather every sibling item that shares the same locator
    // so the backend cancels the whole reservation in one shot.
    // For all other categories, just cancel the single item.
    let productsId: number[] = [item.id];

    if (categoryId === 1 || categoryId === 8) {
      const allItems = this.userService?.itineraryActive?.[0]?.items || [];
      const siblings = allItems.filter(
        (c: any) =>
          c?.resultReserve?.providerReservationId === reservationLocator
      );
      if (siblings.length > 0) {
        productsId = siblings.map((c: any) => c.id);
      }
    }

    return {
      providerId,
      reservationLocator,
      productsId,
    };
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  _payload(item, paxes): any {
    // eslint-disable-next-line max-len
    let productId =
      item.categoryName == "INSURANCE" && item.nameAdapter == "Universal_Assistance"
        ? item.title
        : item.categoryName == "DISNEY"
        ? item.id
        : item.idProduct;
    let searchId = item.categoryName == "DISNEY" ? item.arrayResults[0]["searchId"] : item.searchId;
    let providerId = item.categoryName == "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId;
    const payload = [
      {
        product: {
          searchId: searchId,
          id: item.id,
          providerId: providerId,
          providerName: item.providerName,
          title: item.title,
          description: item.description,
          categoryId: item.category_id,
          productId: productId,
          // eslint-disable-next-line max-len
          origin:
            // eslint-disable-next-line max-len
            item.categoryName != "DISNEY" ? (item.payloadUpdate.products[0].origin ? item.payloadUpdate.products[0].origin : null) : null,
          destination:
            item.categoryName != "DISNEY"
              ? item.payloadUpdate.products[0].destination
                ? item.payloadUpdate.products[0].destination
                : "KOA"
              : item.destination.iata_code,
          // eslint-disable-next-line max-len
          dateIni:
            item.categoryName == "DISNEY"
              ? new DatePipe("en-US").transform(item.destination.destination_info.arrival, "yyyy-MM-dd")
              : item.arrivalDate,
          // eslint-disable-next-line max-len
          dateEnd:
            item.categoryName == "DISNEY"
              ? new DatePipe("en-US").transform(item.destination.destination_info.departure, "yyyy-MM-dd")
              : item.departureDate,
          serviceResponse: null,
          nameAdapter: item.categoryName != "DISNEY" ? item.payloadUpdate.products[0].nameAdapter : "Majestic_Disney",
          // informacion dependiente de cada categoria a reservar
          additionalInfo: this.setAdditionalInfo(item, paxes),
        },
        id: null,
        serviceResponse: null,
      },
    ];
    return payload;
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  getPaxesInfo(paxes: any): any {
    let paxesResult = [];

    paxes.forEach((paxFilter) => {
      let pax = paxes.find((val) => val.document_number == paxFilter.document_number);
      paxesResult.push(pax);
    });

    return paxesResult;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  setAdditionalInfo(item: any, paxes: any): any {
    let additionalInfo;
    switch (item.categoryName) {
      case "HOTELS":
        additionalInfo = {
          hotelId: item.hotelId,
          roomQty: 1,
          arrival: item.arrivalDate,
          departure: item.departureDate,
          rooms: [
            {
              bookParam: item.bookParam,
              roomId: item.roomId ? item.roomId : item.hotelId,
              optionId: item.optionId ? item.optionId : null,
              accomodationId: item.accomodationId ? item.accomodationId : null,
              maxPax: 1,
              netPrice: item.refPrice,
              totalPrice: item.refPriceProf,
              percentage: item.percentage,
              paxList: this.setPaxesReserve(paxes),

              /*
              paxList: {
                pax: this.setPaxesReserve(paxes)
              }
              */
            },
          ],
        };
        break;
      case "TOURS":
        additionalInfo = {
          tours: [
            {
              company: item.company ? item.company : "Agencia de pruebas",
              optionId: item.optionId,
              paxAdults: item.paxAdults,
              paxChildren: item.paxChildren,
              bookingCode: item.bookingCode ? item.bookingCode : null,
              paxList: this.setPaxesReserve(paxes),
              answers: item.questions.length > 0 ? [] : [],
              sessionCode: item.questions.length > 0 ? [] : null,
              languageCode: item.questions.length > 0 ? [] : null,
              hotel: (document.getElementById("hotel-" + item.id) as HTMLInputElement).value,
              netPrice: item.prices.adult,
              /*totalPrice: item.prices.adultProf,
              percentage: item.prices.percentage */
            },
          ],
        };

        break;
      case "TRANSPORTS":
        additionalInfo = {
          bookParam: item.bookParam,
          transfers: [
            {
              oneWay: item.payload.others.transfers.oneWay,
              contractList: item.contractList,
              pickupTime: item.pickupTime,
              dropoffTime: item.dropoffTime,
              pickupLocation: {
                id: item.payload.others.transfers.pickupLocation.id,
                type: item.payload.others.transfers.pickupLocation.type,
              },
              dropoffLocation: {
                id: item.payload.others.transfers.dropoffLocation.id,
                type: item.payload.others.transfers.dropoffLocation.type,
              },
              goingWay: {
                transfersTypeLeg: item.vehicles[0].transfersTypeLeg ? item.vehicles[0].transfersTypeLeg : "IN",
                transferCode: item.vehicles[0].transferCode ? item.vehicles[0].transferCode : "0|0|0",
                transferType: item.vehicles[0].transferType ? item.vehicles[0].transferType : "P",
                vehicleType: item.vehicles[0].transferType ? item.vehicles[0].transferType : 9,
                travelInfo: "xyz",
                travelCompanyName: "avior airline",
                travelDate: item.pickupTime,
                travelTime: item.pickupTime,
              },
              returnWay: {
                transfersTypeLeg: item.vehicles[1].transfersTypeLeg ? item.vehicles[1].transfersTypeLeg : "OUT",
                transferCode: item.vehicles[1].transferCode ? item.vehicles[1].transferCode : "1|0|0",
                transferType: item.vehicles[1].transferType ? item.vehicles[1].transferType : "P",
                vehicleType: item.vehicles[1].transferType ? item.vehicles[1].transferType : 9,
                travelInfo: "abc",
                travelCompanyName: "avianca",
                travelDate: item.dropoffTime,
                travelTime: item.dropoffTime,
              },
              paxList: this.setPaxesReserve(paxes),
              transport: (document.getElementById("transport-" + item.id) as HTMLInputElement).value,
              idTransport: (document.getElementById("idTransport-" + item.id) as HTMLInputElement).value,
              arrivalTime: null, //moment(this._form.get("arrivalTime").toString().split(",")[0]).format("HH:mm"),
              cruiseNumber:
                document.getElementById("cruiseNumber-" + item.id) != null
                  ? (document.getElementById("cruiseNumber-" + item.id) as HTMLInputElement).value
                  : "",
              netPrice: item.payload.others.transfers.totalPrice,
              /*   totalPrice: item.payload.others.transfers.totalPriceProf,
                 percentage: item.payload.others.transfers.percentage */
            },
          ],
        };
        break;
      case "INSURANCE":
        additionalInfo = {
          insurance: {
            price: item.totalPrice,
            /*  totalPrice: item.totalPriceProf,
              percentage: item.percentage, */
            paxList: this.setPaxesReserve(paxes, true),
          },
        };
        break;
      case "PTHEMES":
        additionalInfo = {
          arrival: item.arrivalDate,
          departure: item.departureDate,
          paxList: {
            pax: this.setPaxesReserve(paxes),
          },
          optionId: item.optionId,
          price: item.priceAdults,
          /*totalPrice: item.priceAdultsProf,
          percentage: item.percentage*/
        };
        break;
      case "DISNEY":
        additionalInfo = {
          searchId: item.hotel["additionalInfo"]["searchId"],
          hotelId: item.hotel.id,
          roomId: item.room.roomId,
          accId: item.room.accomodationId,
          rateId: item.plan.rateId,
          ticketTypeId: item.ticket !== undefined ? item.ticket.id : 0,
          mealPlanId: item.mealPlan !== null ? item.mealPlan.id : 0,
          arrivalDate: item.destination.destination_info.arrival,
          departureDate: item.destination.destination_info.departure,
          days: item.days,
          noExpiration: false,
          paxList: this.setPaxesReserve(paxes, true),
          price: item.room.refPrice,
          /* totalPrice: item.room.refPriceProf,
           percentage: item.room.percentage */
        };
        break;
      case "RENT-A-CAR":
        additionalInfo = {
          bookParam: item.bookParam,
          arrival: item.destination.destination_info.arrival,
          departure: item.destination.destination_info.departure,
          paxList: this.setPaxesReserve(paxes, true),
          //hotelId: item.hotel.id,
          //roomId: item.room.roomId,
          optionId: item.optionId,
          accomodationId: item.accomodationId ? item.accomodationId : null,
          maxPax: 1,
          //roomQty: 1,
          searchPax: {
            adults: 1,
            child: 0,
            childAge: {
              int: [0],
            },
          },
        };
        break;
      default:
        break;
    }
    return additionalInfo;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  setPaxesReserve(pax: any, insurance: boolean = false): any {
    let paxesAux = [];
    let i = 0;
    pax.forEach((pax) => {
      let Age = moment().diff(pax.birth_date, "years");
      if (insurance == true) {
        paxesAux.push({
          gender: pax.gender,
          title: pax.title,
          first_name: pax.first_name,
          last_name: pax.last_name,
          identificationType: pax.identificationType,
          type: 'AD',   //AD  CH
          identification: pax.document_number,
          birthDate: pax.birth_date,
          age: Age,
          email: pax.email,
          phone: pax.phone,
          // address: "Agencia de prueba AR",
          // country: 'AR',
          // city: "BUENOS AIRES",
          // state: "MENDOZA",
          address: pax.address,
          country: pax.county,
          city: pax.city,
          state: pax.state,
          holder: 6,
        });
      } else {
        paxesAux.push({
          title: pax.title,
          first_name: pax.first_name,
          last_name: pax.last_name,
          identificationType: pax.identificationType,
          type: 'AD',
          identification: pax.document_number,
          age: Age,
          email: pax.email,
          phone: pax.phone,
          phone2: pax.phone2,
          birthDate: pax.birth_date,
          address: pax.address,
          country: pax.country,
          city: pax.city,
          state: pax.state,
          holder: i == 0 ? "holder" : "",
          postal_code: pax.postal_code,
        });
      }
      i = i + 1;
    });
    return paxesAux;
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  confirmationRedirect(reservationId: number) {
    if (!this.partialReserve) {
      let goToURL: string;
      let navigationExtras: NavigationExtras;

      goToURL = "DetailsSummaryItinerary";
      navigationExtras = {
        queryParams: {
          from: "save-draft-reserve",
          itineraryId: this.itineraryId,
        },
      };
      this._router.navigate([goToURL], navigationExtras);
    } else {
      let goToURL: string;
      let navigationExtras: NavigationExtras;
      goToURL = "DetailsSummaryItinerary";
      navigationExtras = {
        queryParams: {
          from: "partial-reserve",
          itineraryId: this.itineraryId,
        },
      };
      this._router.navigate([goToURL], navigationExtras);
    }
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  postMainTransaction(result) {
    let json = JSON.parse(localStorage.getItem("nrPayment"));

    json.paymentMethods.forEach((element) => {
      element.referenceId = result.id;
    });
    this._restService.doPost("app", "transactionMaster", json).subscribe((response: any) => {
      console.log("responser transaction master", response);
    });
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  saveReservation(reserve: any) {
    reserve["itinerario_id"] = this.itineraryId;
    this._restService.doPost("app", "reservations", reserve).subscribe(
      (response: any) => {
        this.confirmationRedirect(response.data.reservation_id);
        this.ngSpinner.hide();
      },
      (error) => {
        this.ngSpinner.hide();
      }
    );
  }




  /**
   *
   * @param idProduct
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  _validateItem(id: any): any {
    let index = -1;

    if (this.itinerary.items !== undefined && this.itinerary.items.length > 0) {
      // eslint-disable-next-line guard-for-in
      for (let position in this.itinerary.items) {
        for (let position2 in this.itinerary.items[position].arrayResults) {
          if (this.itinerary.items[position].arrayResults[position2].productId == id) {  //productId
            return parseInt(position);
          }
        }
        if (this.itinerary.items[position].id == id) {  //idProduct
          return parseInt(position);
        }
      }
    } else {
      // console.log("No products in > ", this.itinerary);
    }
    return index;
  }

  /**
   *
   * @param arrivalDate
   * @param departureDate
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  _validateDate(arrivalDate: any, departureDate: any): any {
    if (this.itinerary["arrivalDate"] == arrivalDate && this.itinerary["departureDate"] == departureDate) {
      return true;
    }
    return false;
  }

  /**
   *
   * @param items
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  evaluateDateItineraryRange(items: any): RangeDateItinerary {


    let dateRange: RangeDateItinerary;
    // if (items != null && items.length > 0) {
    let arrivalDate = items.arrivalDate;
    let departureDate = items.departureDate;
    // for (let item in items) {
    // 	if (items[item].departureDate > departureDate) {
    // 		departureDate = items[item].departureDate;
    // 	}
    // 	if (items[item].arrivalDate < arrivalDate) {
    // 		arrivalDate = items[item].arrivalDate;
    // 	}
    // }
    dateRange = { arrivalDate: new Date(), departureDate: new Date() };
    dateRange.arrivalDate = arrivalDate;
    dateRange.departureDate = departureDate;
    // }
    return dateRange;
  }

  /**
   *
   * @param keyword
   */
  getClients(keyword): Observable<any> {
    if (keyword) {
      return this.http.get(this.clients + keyword);
      // .map(res => {
      // 	let json = res.json().data;
      // 	return json;
      // })
    } else {
      return Observable.of([]);
    }
  }

  /**
   *
   * @param data
   * @param newItinerary
   * @param itineraryId
   */
  postDataClient(data: any, newItinerary?: Boolean, itineraryId?: Number): Observable<any> {
    data.country = null;
    data.city = null;
    data.state = null;
    data.address = null;
    //data.birth_date = "1950-01-01";
    data.birth_date = new DatePipe("en-US").transform("1950-12-13", "yyyy-MM-dd");

    return this._restService.doPost("app", "clients", data);
  }

  addClientToAgency(data: any): Observable<any> {
    return this._restService.doPost("app", "clients/agency", data);
  }

  /**
   *
   * @param data
   * @param key
   */
  updateClient(data, key?: Boolean): Observable<any> {
    let route = "clients/" + data.id;
    return this._restService.doPut("app", route, data);
  }

  /**
   *
   * @param data
   * @param status
   * @param uid
   * @param redirect
   */
  postDataItinerary(data, status: String, uid?: number, redirect?: boolean) {

    // this.itinerary$.subscribe((data: any) => {

    data.status = status;
    data.uid = uid === undefined ? this.randomNumber(1, 100000) : uid;
    data.agent_id = this.userService._agentID;
    data.agency_id = this.userService._agencyID;
    data.status_id = "1";
    data.location = null;
    data.origin = null;
    data.arrivalDate = null;
    data.departureDate = null;
    data.currency = null;
    data.active = 1;
    data.data = null;
    this.updateItinerary(data, redirect);
  // })
  }

  /**
   *
   * @param data
   * @param redirect
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  updateItinerary(data: any, redirect?: boolean) {
    this._restService.doPost("app", "itineraries", data).subscribe(
      (response: any) => {
        if (response.success) {
          this.forceConsultActiveItinerary(this.userService._agentID, redirect);
        }
      },
      (error) => {
        console.log("Save-Error: " + error);
      }
    );
  }

  /**
   *
   */
  clearItinerary() {
    this.itinerary = {};
  }

  /**
   *
   * @param itinerary
   * @param update
   */
  emitActiveItinerary(itinerary: any, update: boolean) {
    //console.log(JSON.stringify(itinerary));
    if (update) {
      this.updateActiveItinerary(itinerary[0], itinerary[0].active);
    } else {
      this.itinerary = itinerary[0];
      this.sendMessageActiveItinerary(itinerary);
    }
    this.sendMessageSubscriptorMap(itinerary);
  }
  /**
   *
   * @param data
   */
  sendMessageSubscriptorMap(data: any) {
    this.objectMap = data;
    this.objectMapSubject.next(data);

  }

  /**
   *
   * @param loading
   */
  sendMessageSubscriptorLoading(loading: any) {
    this.loadingObject = loading;
    this.loadingObjectSubject.next(loading);
  }

  /**
   *
   * @param destiny
   * @param category
   * @param data
   * @param delete
   */
  sendMessageSubscriptorItemSelected(destiny?: string, category?: string, data?: any, prueba?: boolean) {
    var item: ItemSelected = this.inizializedItemSelected();
    item.data = data !== undefined && data !== null ? data : this.itinerary;
    item.category = category;
    item.destiny = destiny;
    item.delete = prueba;


    //console.log("envio itemSelectedMulti next", item);
    this.itemSelectedMultidestinationSubject.next(item);
  }

  private inizializedItemSelected(): ItemSelected {
    const item: ItemSelected = {
      destiny: undefined,
      category: undefined,
      data: undefined,
      more: undefined,
    };
    return item;
  }

  /**
   *
   * @param itinerary
   * @param active
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  updateActiveItinerary(itinerary, active, module?: string, noActivePrevious?: boolean) {

    if(module === 'client') {
      itinerary.clientModule = true;
    }
    itinerary.active = active ? 1 : 0;
    // itinerary.agent_id = '1';
    itinerary.status_id = "1";
    let route = "itineraries/" + itinerary.id;
    // console.log(itinerary)
    this._restService.doPut("app", route, itinerary).subscribe({
      next: (response: any) => {

        if (response.success) {

          if (!active) {
            this.itinerary = {};
            // this.sendMessageActiveItinerary(response.success);

            this.consultActiveItinerary(this.userService._agentID, false, itinerary.id, `${module}_active`);
          }
          if(!noActivePrevious) {
            this.consultActiveItinerary(this.userService._agentID, false, itinerary.id, `${module}_deactive`);
          }
          this.loading = false;
          //this.consultActiveItinerary(1);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log("Update-Itinerary-Error: " + error);
      }
    });
  }

  /**
   *
   * @param agent_id
   * @param redirect
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
// ✅ Flag para evitar llamadas simultáneas
    private isConsulting = false;
    private consultTimeout: any = null;
    private lastConsultParams: string = '';
     private _consultSubscription: Subscription;

    async consultActiveItinerary(agent_id?, redirect?: boolean, itineraryId?: number, component?: string) {
        // ✅ Evitar llamadas si ya está en ejecución
        if (this.isConsulting) {
            return;
        }
        // ✅ Evitar llamadas duplicadas con los mismos parámetros
        const paramsKey = `${agent_id}_${this.itinerary?.id || itineraryId}_${component}`;
        if (this.lastConsultParams === paramsKey) {
            return;
        }
        this.lastConsultParams = paramsKey;

        // ✅ Limpiar timeout anterior si existe
        if (this.consultTimeout) {
            clearTimeout(this.consultTimeout);
            this.consultTimeout = null;
        }

        this.isConsulting = true;

        // ✅ Usar switchMap o unsubscribe para cancelar la anterior
        if (this._consultSubscription && !this._consultSubscription.closed) {
            this._consultSubscription.unsubscribe();
        }

        this._activePages = 1;

        if (agent_id == undefined && localStorage.getItem("selectedAgency")) {
            let agent = JSON.parse(localStorage.getItem("selectedAgency"));
            agent_id = agent.agent_id;
        }

        let url: string = `itineraries?active_agent_id=${agent_id}&active=1`;

        try {
            this._consultSubscription = await this._restService.doGet("app", url).subscribe({
                next: (response: any) => {

                    this.isConsulting = false;

                    if (Object.keys(response.data).length > 0) {
                        if (response.data[0].client_id !== null) {
                            response.data[1] = response.data[0].clients;
                            this.captureVolatileItemFields(this.itinerary?.items);
                            this.itinerary = response.data[0];
                            this.restoreVolatileItemFields(response.data[0].items);
                            this.captureVolatileItemFields(response.data[0].items);
                            this.sendMessageActiveItinerary(response.data);
                        }
                        if (redirect) {
                            // this._router.navigate(["results"]);
                        }
                    } else {
                        this.sendMessageActiveItinerary(response.data);
                    }

                    // ✅ Resetear el cache después de un tiempo
                    this.consultTimeout = setTimeout(() => {
                        this.lastConsultParams = '';
                    }, 5000);
                },
                error: (error: any) => {
                    console.log("Save-Error: " + error);
                    this.isConsulting = false;
                }
            });
        } catch (error) {
            console.error('Error en consultActiveItinerary:', error);
            this.isConsulting = false;
        }
    }

    // ✅ Método para forzar la consulta (cuando sea necesario)
    forceConsultActiveItinerary(agent_id?, redirect?: boolean, itineraryId?: number) {
        this.lastConsultParams = ''; // Resetear cache
        this.consultActiveItinerary(agent_id, redirect, itineraryId);
    }

    /**
     * amenitiesIncluded/addonsIncluded se pierden entre distintos fetchs del mismo
     * itinerario (el backend no los devuelve de forma consistente en cada
     * consulta, independientemente de la categoría del producto). Se cachean acá,
     * en el servicio (singleton), para que sobrevivan aunque itinerary-detail se
     * destruya y recree (navegación, apertura de modales, etc.), y se reponen por
     * item.id -que ya es único una vez guardado el producto en el backend-
     * cuando un fetch nuevo viene vacío pero antes lo tuvimos con datos.
     */
    private volatileItemFieldsCache = new Map<number, { amenitiesIncluded?: any[]; addonsIncluded?: any[] }>();

    captureVolatileItemFields(items: any[]): void {
        (items || []).forEach((item: any) => {
            if (item?.id != null && (item.amenitiesIncluded?.length || item.addonsIncluded?.length)) {
                this.volatileItemFieldsCache.set(item.id, {
                    amenitiesIncluded: item.amenitiesIncluded,
                    addonsIncluded: item.addonsIncluded
                });
            }
        });
    }

    restoreVolatileItemFields(items: any[]): void {
        if (!items || this.volatileItemFieldsCache.size === 0) {
            return;
        }
        items.forEach((item: any) => {
            if (item?.amenitiesIncluded?.length || item?.addonsIncluded?.length) {
                return;
            }
            const cached = item?.id != null ? this.volatileItemFieldsCache.get(item.id) : null;
            if (!cached) {
                return;
            }
            if (cached.amenitiesIncluded?.length) {
                item.amenitiesIncluded = cached.amenitiesIncluded;
            }
            if (cached.addonsIncluded?.length) {
                item.addonsIncluded = cached.addonsIncluded;
            }
        });
    }
  /**
   *
   * @param data
   */
  sendMessageActiveItinerary(data: any) {
    // this.activeItinerary = data;
    this.userService.itineraryActive = data;
    this.userService.calculateDates();
    this.itinerary$.next(data);
    this.userService.fillCart(data);
    this.activeItinerarySubject.next(data);
  }

  getItinerary$(): Observable<any> {
    return this.itinerary$.asObservable();
  }

  /**
   *
   * @param id
   */
  deleteItinerary(id: number): Observable<any> {
    return this._restService.doDelete("app", "itineraries/" + id);
  }

  /**
   *
   * @param activePages
   */
  getItineraries(activePages?: number) {
    let have = activePages === undefined ? 1 : activePages;

    if (this.userService._agentID == undefined && localStorage.getItem("selectedAgency")) {
      let agent = JSON.parse(localStorage.getItem("selectedAgency"));
      this.userService._agentID = agent.agent_id;
    }

    if (have === 1) {
      this.apiService.doGet("itineraries?page=" + have + "&agent_id=" + this.userService._agentID).subscribe(
        (Response) => {
          if (Response.length > 0) {
            this.itineraries = Response;
            this.itinerariesSubject.next(this.itineraries);
          }
        },
        (error) => {
          console.log("Error: " + error);
        }
      );
    } else {
      let it = this.itineraries;
      this.apiService.doGet("itineraries?page=" + have + "&agent_id=" + this.userService._agentID).subscribe(
        (Response) => {
          if (Response.length > 0) {
            it = it.concat(Response);
            this.itineraries = it;
            this.itinerariesSubject.next(this.itineraries);
          }
        },
        (error) => {
          console.log("Error: " + error);
        }
      );
    }
  }

  /**
   *
   */
  public handleError = (error: Response) => {
    this.logger.error(error);
    return Observable.throw(error);
  };

  /**
   *
   */
  private get _headers(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("client-id", environment.client_id);
    headers.append("client-secret", environment.client_secret);
    if (localStorage.getItem("bearer")) {
      headers.append("Authorization", "Bearer " + localStorage.getItem("bearer"));
      //headers.append('Authorization', 'Bearer ' +  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjgzNDEyMDg0OTU4NmUwZDEzOTMwZjMxODUxYjVmMDU3ZDdlYjZjNmEyNzJmYTdiZDVmNmU2OGI5YjA4MjQ2YmE2OTBlZjQzNGM3ZmZjNGQ0In0.eyJhdWQiOiIxNyIsImp0aSI6IjgzNDEyMDg0OTU4NmUwZDEzOTMwZjMxODUxYjVmMDU3ZDdlYjZjNmEyNzJmYTdiZDVmNmU2OGI5YjA4MjQ2YmE2OTBlZjQzNGM3ZmZjNGQ0IiwiaWF0IjoxNjA5MTcwNjUwLCJuYmYiOjE2MDkxNzA2NTAsImV4cCI6MTY0MDcwNjY1MCwic3ViIjoiNiIsInNjb3BlcyI6W119.NE-oOiyB11RI1pFgyPutvrdtMyzgwZW9BluwQmr1d5t3eVc5gFtjwHr4JEH5mLXTF5xRot9EXz-4B8wNemCir1-G_DDYfh5gr2TDgg62Vm5gsuepIDvRJ_xMpNEzMltQ9q1wD7Y4EbuJNs1LLBZNo6aNNNYnHkaM8U34m1E_K1foqo09X_7zGSrioUhZnHS1CBomfq3qZPKmsWxNuBF1PljEk0pnC6ikuLrMvNObQX4UXTUn0x4TySQ4k6OlX7RmCveordxDATZ9dyqQ4QsPUBEN9vlANMDu_8NYcW3Gp0yztUXFCnh6Ku1F5oBCmi8tCcuKb3Ji1Z1qL6nCF3j1UYVdVRheVnojjs5joK4CA4sw8j239Zqh-II_grzhBQuF570W8ziT-NAabfEf53u65hK0iPpr5HRYJX0OpRc9s6qe0w76RnSNdmEU4rA5M1cviTWomHKZ2bZVWfR5ExyMIvOBteH2Y8EClyfb4lYsgdcyclpCAb5jyj2UOeHeGRy5VH6DqVWnV9BkQipsIB3UoKfcnOsUvvZjqKsiNo8ERR24n6lz_fOZ2d0j1Fwsivq8FZTY5-wt8KUoSq1uxvs1UKJlK3L6zpiDPgEeAuA2aQ1S-ADO-3vRjdsEZDqaarOm4eXEqotGv1Xsw0fyPdbEb3nFoC4zSHmZJje6aqpRioM');
    }
    return headers;
  }
  /**
   *
   * @param min
   * @param max
   */
  randomNumber(min, max) {
    return Math.round(Math.random() * (max - min) + min);
  }
  /**
   *
   * @param date1
   * @param date2
   */
  _difference(date1: any, date2: any): any {
    const first = moment(date1);
    const second = moment(date2);
    //console.log(first)
    return first.diff(second, "days") === 0 ? "exactly" : first.diff(second, "days") < 0 ? "earlier" : "later";
  }
  /**
   *
   * @param itinerary
   */
  _orderSummaryDestinations(itinerary: any): Array<any> {
    const destinations = [];
    itinerary["items"].forEach((item) => {
      if (destinations.length === 0) {
        destinations.push({
          arrival: item["arrivalDate"],
          departure: item["departureDate"],
          destination: item["categoryName"] === "HOTELS" ? item["payloadUpdate"]["products"][0]["destination"] : null,
          product: [
            {
              item: item,
            },
          ],
        });
      } else {
        destinations.forEach((destination) => {
          if (item["departureDate"]) {
            //console.log(this._difference('2018-04-03', '04-25-2018'));
          }
        });
      }
    });
    return destinations;
  }


  /**
   *
   * @param form
   * @param payload
   */
  // eslint-disable-next-line @typescript-eslint/member-ordering
  getDestinationInfo(form: any, payload: any): any {
    this.itinerary = this.userService.itineraryActive[0];
    let iata_code;
    let cityName;
    let child;
    let adults;
    let ages: Array<any> = [];
    let agesAdults: Array<any> = [];
    let roomsDist;
    let roomsQty;
    let object;
    let adultsRoom;
    let childrenRoom;
    let ageRoom: Array<any> = [];
    let agesAdultsRoom: Array<any> = [];
    let nights = 0;
    let departureDate: string;
    let arrivalDate: string;

    if (form) {
      if (form.destination) {
        if (payload.categoryName == "INSURANCE") {
          iata_code = form.destination.iataCode;
          // cityName = this.titleCasePipe.transform(form.destination.name);
        } else {
          iata_code = form.destination.cityIataCode;
          if (iata_code == null) {
            iata_code = payload.payloadUpdate.products[0].destination;
          }
          cityName = this.titleCasePipe.transform(form.destination.cityName);
        }
      }
    }
    // else if (payload.payloadUpdate.products[0].destination){
    // 	iata_code = payload.payloadUpdate.products[0].destination;
    // }


    if (payload) {
      switch (payload.categoryName) {
        case "PTHEMES":
          adults = payload.paxAdults;
          child = payload.paxChild;
          ages = payload.payloadUpdate.products[0].others.ages;
          departureDate = payload.departureDate;
          arrivalDate = payload.arrivalDate;
          nights = 1;
          break;
        case "TOURS":
          object = payload.payloadUpdate.products[0];
          adults = object["others"]["tours"]["adults"];
          child = object["others"]["tours"]["children"].length;
          ages = object["others"]["tours"]["children"];
          departureDate = object.departureDate;
          arrivalDate = object.arrivalDate;

          nights = 1;
          if (form) {
            if (form.destination === null || form.destination === undefined) {
              if (payload.categoryName == "INSURANCE") {
                iata_code = form.origin.iataCode;
                cityName = this.titleCasePipe.transform(form.origin.name);
              } else {
                iata_code = payload.payloadUpdate.products[0].destination;
              }
            }
          }
          break;
        case "TRANSPORTS":
          object = payload.payload[0];
          adults = object["transfers"]["paxList"]["adults"];
          child = object["transfers"]["paxList"]["children"].length;
          ages = object["transfers"]["paxList"]["children"];
          departureDate = object["pickupDate"];
          arrivalDate = object["pickupDate"];
          nights = 0;
          if (form) {
            iata_code = object["transfers"]["dropoffLocation"].destination;
            cityName = this.titleCasePipe.transform(form.firstDestination.city_name) || this.titleCasePipe.transform(form.firstDestination.name) || this.titleCasePipe.transform(form.firstDestination.value);
          }
          break;
        case "INSURANCE":
          adults = payload?.adults;
          child = payload?.childrens;
          ages = payload?.pax?.ages;
          nights = moment(payload.payload.dateEnd).diff(payload.payload.dateBegin, "days");
          agesAdults = agesAdultsRoom;
          departureDate = payload.payload.dateBegin;
          arrivalDate = payload.payload.dateEnd;
          if (form) {
            iata_code = form.destination.label;
          }
          break;
        case "DISNEY":
          adultsRoom = 0;
          childrenRoom = 0;
          payload.form.room.forEach((room) => {
            adultsRoom += Number.parseInt(room.qtyAdults);
            childrenRoom += Number.parseInt(room.qtyChilds);
            room.childsage.forEach((age) => {
              ageRoom.push(age.age);
            });
          });
          adults = adultsRoom;
          child = childrenRoom;
          ages = ageRoom;
          nights = payload.room.nights;
          departureDate = payload.form.departureDate;
          arrivalDate = payload.form.arrivalDate;
          iata_code = payload.hotel.destination;
          cityName = this.titleCasePipe.transform(payload.hotel.serviceResponse.City);
          roomsDist = payload.form.room;
          roomsQty = payload.form.room ? payload.form.room.length : null;
          break;
        case "HOTELS":
          adultsRoom = 0;
          childrenRoom = 0;

          //object = payload.payloadUpdate.products ? payload.payloadUpdate.products[0] : payload.payloadUpdate;
          object = payload.payloadUpdate.products[0];

          object.others.hotels.roomConfiguration.forEach((room) => {
            adultsRoom += Number.parseInt(room.adults);
            childrenRoom += Number.parseInt(room.children.length);
            room.children.forEach((age) => {
              ageRoom.push(age);
            });
          });
          adults = adultsRoom;
          child = childrenRoom;
          ages = ageRoom;
          roomsDist = object.others.hotels.roomConfiguration;
          roomsQty = object.others.hotels.roomConfiguration ? object.others.hotels.roomConfiguration.length : null;
          nights = moment(object.departureDate).diff(object.arrivalDate, "days");
          departureDate = object.departureDate;
          arrivalDate = object.arrivalDate;
          if (form) {
            if (form.destination === null || form.destination === undefined) {
              if (payload.categoryName == "INSURANCE") {
                iata_code = form.origin.iataCode;
                // cityName = this.titleCasePipe.transform(form.origin.name);
              } else {
                iata_code =  object.destination/// payload.hotel.destination;
              }

            }
          }

          break;
        case 'FLIGHTS': {
          object = payload.payloadUpdate.products[0];
          const flightsSearchPayload = Array.isArray(payload.payload) ? payload.payload[0] : payload.payload;
          adults = flightsSearchPayload?.others?.tours?.adults || 0;
          child = flightsSearchPayload?.others?.tours?.children?.length || 0;
          ages = flightsSearchPayload?.others?.tours?.children || [];
          // Igual que HOTELS: arrival = fecha más temprana (ida), departure =
          // fecha más tardía (vuelta). object.departureDate/returnDate son los
          // nombres del payload de vuelos (ida/vuelta), no arrival/departure.
          arrivalDate = object.departureDate;
          departureDate = object.returnDate || object.departureDate;
          iata_code = object.destination;
          cityName = object.destination;
          nights = 0;
          break;
        }
        case "BOATS":
          object = payload.payloadUpdate.products[0];
          adults = object.boats?.adults || 0;
          child = object.boats?.children?.length || 0;
          ages = object.boats?.children || [];
          arrivalDate = object.arrivalDate;
          departureDate = object.departureDate;
          nights = payload.nights || moment(object.departureDate).diff(object.arrivalDate, "days");
          iata_code = form?.destination?.cityIataCode || object.destination;
          cityName = this.titleCasePipe.transform(form?.destination?.cityName);
          break;
        case "RENT-A-CAR":
          console.log('form', form);
          object = payload.payloadUpdate.products[0];
          //parts = object.departureDate.split('-');
          //mydate = new Date(parts[0], parts[1] - 1, parts[2]);
          //departureDate = mydate;
          departureDate = object.departureDate;
          //parts = object.arrivalDate.split('-');
          //mydate = new Date(parts[0], parts[1] - 1, parts[2]);
          nights = moment(object.departureDate).diff(object.arrivalDate, "days");
          adults = 0;
          child = 0;
          //arrivalDate = mydate;
          arrivalDate = object.arrivalDate;
          if (form) {
            if (form.destination === null || form.destination === undefined) {
              if (payload.categoryName == "INSURANCE") {
                iata_code = form.origin.city_iata_code;
                // cityName = this.titleCasePipe.transform(form.origin.name);
              } else {
                iata_code = object.destination; //form.origin.cityIataCode
                cityName = this.titleCasePipe.transform(form.origin?.name);
              }
            }
          }
          break;
      }
      if(payload.categoryName === 'TRANSPORTS') {
        const destination = {
          iata_code: iata_code,
          destination_info: {
            cityName: cityName,
            nights: nights,
            adults: adults,
            childs: child,
            childsAges: ages,
            agesAdults: agesAdults,
            rooms: roomsQty,
            roomDist: roomsDist,
            position: this.itinerary?.destination.length + 1,
            arrival: arrivalDate,
            departure: departureDate,
          },
        };
          if (destination.iata_code === null || destination.iata_code === undefined) {
            return "valor null";
          }
              if (this.itinerary["destination"].length > 0) {
            const existingIndex = this.itinerary["destination"].findIndex(
              _destination => _destination["iata_code"] && destination["iata_code"] === _destination["iata_code"]
            );

            if (existingIndex !== -1) {
              // ENCONTRADO: Sumar adultos y niños al destino existente
              this.itinerary.destination[existingIndex].destination_info.adults += destination.destination_info.adults;
              this.itinerary.destination[existingIndex].destination_info.childs += destination.destination_info.childs;

            } else {
              // NO ENCONTRADO: Agregar nuevo destino
              this.itinerary["destination"].push(destination);
            }
          } else {
            // Array vacío: Agregar primer destino
            this.itinerary["destination"].push(destination);
          }

        return destination;
      } else {
        const destination = {
          iata_code: iata_code,
          destination_info: {
            cityName: form.destination?.city_name || form.origin?.city_name || form.firstDestination?.city_name || form.origin?.name,
            nights: nights,
            adults: adults,
            childs: child,
            childsAges: ages,
            agesAdults: agesAdults,
            rooms: roomsQty,
            roomDist: roomsDist,
            position: this.itinerary?.destination && this.itinerary?.destination.length > 0 ? this.itinerary?.destination.length + 1 : 1,
            arrival: arrivalDate,
            departure: departureDate,
          },
        };

        if (destination.iata_code === null || destination.iata_code === undefined) {
          return "valor null";
        }
       if (this.itinerary["destination"].length > 0) {
          const existingIndex = this.itinerary["destination"].findIndex(
            _destination => _destination["iata_code"] && destination["iata_code"] === _destination["iata_code"]
          );

          if (existingIndex !== -1) {
            // ENCONTRADO: Sumar adultos y niños al destino existente
            this.itinerary.destination[existingIndex].destination_info.adults += destination.destination_info.adults;
            this.itinerary.destination[existingIndex].destination_info.childs += destination.destination_info.childs;

          } else {
            // NO ENCONTRADO: Agregar nuevo destino
            this.itinerary["destination"].push(destination);
          }
        } else {
          // Array vacío: Agregar primer destino
          this.itinerary["destination"].push(destination);
        }

        return destination;
      }
      // console.log(this.itinerary)
      // this.updateItinerary(this.itinerary);
    }
    return null;
  }

   updateParcialBlickoins(value: number) {
    this.parcialBlickoins = value;
    // console.log(this.parcialBlickoins);
    // Aquí puedes realizar cualquier otra lógica que necesites con el nuevo valor
  }

  updateItineraryPartial(item: any, remove: boolean = false) {

//     console.log(item)

//     console.log("remove", remove);

// console.log(this._router.url)
// console.log(this.parcialBlickoins)

    if (remove) {
      let validate = this.itemEmptyItemItineraryPartial();
      const index = this._getItemIndexItineraryPartial(item.idProduct);


      // Enviando datos
      let data: any;
      data = {
        partial_selected: 0,
        item_id: item.id,
      };
      let itemId = encodeURIComponent(item.id);
      this._restService.doPut("app", "products/set/partial/" + item.itinerary_id, data).subscribe(
        (response: any) => {
          if (response.success) {
            //this.itineraryPartial.push(item.idProduct);

            this.parcialTotalPrice = this.parcialTotalPrice - item.totalPrice;
            this.parcialBlickoins = this.parcialBlickoins - item.blickoins;


            if (validate && index > -1) {
              this.itineraryPartial.splice(index, 1);
            }

            return this.itineraryPartial;
          }
        },
        (error) => {
          console.log("Save-Error: " + error);
        }
      );
        //  this.userService.totalPriceNotFeeByReservedAgency = this.userService.totalPriceNotFeeByReservedAgency - item.netPriceAgent;
        //     this.userService.totalPriceYesFeeByReservedAgency = this.userService.totalPriceYesFeeByReservedAgency - item.netPriceAgent;
      //final de envio de datos
    } else {
      //agregamos el itinerario
      let data: any;
      data = {
        partial_selected: 1,
        item_id: item.id,
      };
      let itemId = encodeURIComponent(item.id);
      this._restService.doPut("app", "products/set/partial/" + item.itinerary_id, data).subscribe(
        (response: any) => {
          if (response.success) {
            this.itineraryPartial.push(item.idProduct);


            let priceTotal = 0;
            let blickoins = 0;

            this.itineraryPartial.forEach((element) => {
              let item = this.userService.itineraryActive[0].items.find((item) => item.idProduct == element);
              if (item) {
                priceTotal = priceTotal + item.totalPrice;
                blickoins = blickoins + item.blickoins;
              }
            });

            this.parcialTotalPrice = priceTotal;
            this.parcialBlickoins = blickoins;
            this.ngSpinner.hide();

            // console.log("   this.itineraryPartial",    this.itineraryPartial);
            return this.itineraryPartial;
          } else {
            console.log("parcial error ==> ", this.itineraryPartial);
          }
        },
        (error) => {
          this.ngSpinner.hide();
          console.log("Save-Error: " + error);
        }
      );
    }
  }

    // ✅ Flag para evitar llamadas simultáneas
    private isRemovingPartial = false;
    private removePartialTimeout: any = null;
    private lastRemovePartialId: any = null;
    private _removePartialSubscription: Subscription;

    updateRemoveItineraryPartial(itinerary: any) {
        // ✅ Evitar llamadas si ya está en ejecución
        if (this.isRemovingPartial) {
            return;
        }

        // ✅ Evitar llamadas duplicadas con el mismo ID
        if (this.lastRemovePartialId === itinerary) {
            return;
        }
        this.lastRemovePartialId = itinerary;

        // ✅ Limpiar timeout anterior
        if (this.removePartialTimeout) {
            clearTimeout(this.removePartialTimeout);
            this.removePartialTimeout = null;
        }

        this.isRemovingPartial = true;
        let data: any;
        let itineraryId = itinerary;

        // ✅ Guardar referencia a la suscripción para poder cancelarla
        if (this._removePartialSubscription && !this._removePartialSubscription.closed) {
            this._removePartialSubscription.unsubscribe();
        }

        this._removePartialSubscription = this._restService.doPut("app", "products/revert/partial/" + itineraryId, data)
            .subscribe({
                next: (response: any) => {
                    this.isRemovingPartial = false;
                    if (response.success) {
                    }
                    // ✅ Resetear el cache después de un tiempo
                    this.removePartialTimeout = setTimeout(() => {
                        this.lastRemovePartialId = null;
                    }, 3000);
                },
                error: (error: any) => {
                    console.log("❌ Save-Error:", error);
                    this.isRemovingPartial = false;
                }
            });
    }

    // ✅ Método para forzar (cuando sea necesario)
    forceUpdateRemoveItineraryPartial(itinerary: any) {
        this.lastRemovePartialId = null;
        this.updateRemoveItineraryPartial(itinerary);
    }

  itemEmptyItemItineraryPartial() {
    if (typeof this.itineraryPartial !== undefined) {
      if (this.itineraryPartial.length > 0) {
        return true;
      }
    }
    return false;
  }

  _getItemIndexItineraryPartial(idProduct: any): any {
    let index = -1;
    if (this.itineraryPartial.length > 0) {
      for (let position in this.itineraryPartial) {
        for (let position2 in this.itineraryPartial[position]) {
          if (this.itineraryPartial[position] == idProduct) {
            return parseInt(position);
          }
        }
        if (this.itineraryPartial[position].idProduct == idProduct) {
          return parseInt(position);
        }
      }
    } else {
      console.log("No products in > ", this.itineraryPartial);
    }
    return index;
  }

  /* NUEVO METODOS */

  /**
   *
   * @param itinerary
   */
  // Obtener los datos del vuelo
  initFlights(itinerary: any) {

    let flightInfo: any;
    this._restService.doGet("app", "itinerary/" + Number(this.itinerary["id"]) + "/fly").subscribe(
      (response: any) => {
        if (response["data"] && response["data"][0]) {
          const flight = response["data"][0];
          flightInfo = {
            departureDate: new Date(flight["departure"]),
            arrivalDate: new Date(flight["arrival"]),
            airport: flight["airport"],
            airline: flight["airline"],
            flightNumber: flight["flyNumber"],
          };
        }
      },
      (error) => {
        console.log("Has no flights associated", error);
      }
    );
    return flightInfo;
  }

  /**
   *
   * @param item
   */
  // Obtener la localizacion del item
  getLocation(item: any): string {
    let location;
    switch (item.categoryName) {
      case "DISNEY":
        location = item.hotel.additionalInfo.location;
        break;
      case "INSURANCE":
        location = item.destination.iata_code;
        break;
      default:
        location = item.location;
        break;
    }
    return location;
  }
  /**
   *
   * @param item
   */
  // Obtener la descripcion del item
  getDescription(item: any): string {
    let description;
    switch (item.categoryName) {
      case "DISNEY":
        description = item.hotel.additionalInfo.description;
        break;
      default:
        description = item.description;
        break;
    }
    return description;
  }
  // Obtener la descripcion los pasajeros
  getPaxList(itinerary: any) {
    let adults = 0;
    let children = 0;
    let rooms = 0;
    let nights = 0;
    let object;
    let adultsRoom = 0;
    let childrenRoom = 0;
    let departureDate = new Date(1, 1, 1);
    let arrivalDate = new Date(3000, 1, 1);
    if (itinerary.items.length > 0) {
      itinerary.items.forEach((item) => {
        switch (item.categoryName) {
          case "PTHEMES":
            adults = this.selectGreaterValue(item.paxAdults, adults);
            children = this.selectGreaterValue(item.paxChild, children);
            rooms = this.selectGreaterValue(0, rooms);
            // nights += item.duration;
            departureDate = this.selectGreaterValue(new Date(item.departureDate), new Date(departureDate));
            arrivalDate = this.selectMinValue(new Date(item.arrivalDate), new Date(arrivalDate));
            break;
          case "TOURS":
            object = item.payloadUpdate.products[0];
            adults = this.selectGreaterValue(object["others"]["tours"]["adults"], adults);
            children = this.selectGreaterValue(object["others"]["tours"]["children"].length, children);
            rooms = this.selectGreaterValue(0, rooms);
            // nights += moment(object.departureDate).diff(object.arrivalDate, 'days');
            let parts = object.departureDate.split("-");
            let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
            departureDate = this.selectGreaterValue(mydate, new Date(departureDate));
            parts = object.arrivalDate.split("-");
            mydate = new Date(parts[0], parts[1] - 1, parts[2]);
            arrivalDate = this.selectMinValue(mydate, new Date(arrivalDate));
            break;
          case "TRANSPORTS":
            object = item.payload.others;
            adults = this.selectGreaterValue(object["transfers"]["paxList"]["adults"], adults);
            children = this.selectGreaterValue(object["transfers"]["paxList"]["children"].length, children);
            rooms = this.selectGreaterValue(0, rooms);
            // nights += moment(item.payload.departureDate).diff(item.payload.arrivalDate, 'days');
            departureDate = this.selectGreaterValue(new Date(item.payload.departureDate), new Date(departureDate));
            arrivalDate = this.selectMinValue(new Date(item.payload.arrivalDate), new Date(arrivalDate));
            break;
          case "INSURANCE":
            adultsRoom = 0;
            childrenRoom = 0;
            item.form.room.forEach((room) => {
              adultsRoom += Number.parseInt(room.qtyAdults);
              childrenRoom += Number.parseInt(room.qtyChilds);
            });
            adults = this.selectGreaterValue(adultsRoom, adults);
            children = this.selectGreaterValue(childrenRoom, children);
            rooms = this.selectGreaterValue(0, rooms);
            departureDate = this.selectGreaterValue(new Date(item.form.departureDate), new Date(departureDate));
            arrivalDate = this.selectMinValue(new Date(item.form.arrivalDate), new Date(arrivalDate));
            // nights += moment(item.departureDate).diff(item.arrivalDate, 'days');
            break;
          case "DISNEY":
            adultsRoom = 0;
            childrenRoom = 0;
            item.form.room.forEach((room) => {
              adultsRoom += Number.parseInt(room.qtyAdults);
              childrenRoom += Number.parseInt(room.qtyChilds);
              rooms++;
            });
            adults = this.selectGreaterValue(adultsRoom, adults);
            children = this.selectGreaterValue(childrenRoom, children);
            rooms = this.selectGreaterValue(item.form.room.length, rooms);
            nights += item.room.nights;
            departureDate = this.selectGreaterValue(new Date(item.form.departureDate), new Date(departureDate));
            arrivalDate = this.selectMinValue(new Date(item.form.arrivalDate), new Date(arrivalDate));
            break;
          case "HOTELS":
            adultsRoom = 0;
            childrenRoom = 0;
            object = item.payloadUpdate.products[0];
            object.others.hotels.roomConfiguration.forEach((room) => {
              adultsRoom += Number.parseInt(room.adults);
              childrenRoom += room.children.length;
            });
            adults = this.selectGreaterValue(adultsRoom, adults);
            children = this.selectGreaterValue(childrenRoom, children);
            rooms = this.selectGreaterValue(object.others.hotels.roomConfiguration.length, rooms);
            nights += moment(object.departureDate).diff(object.arrivalDate, "days");
            departureDate = this.selectGreaterValue(new Date(object.departureDate), new Date(departureDate));
            arrivalDate = this.selectMinValue(new Date(object.arrivalDate), new Date(arrivalDate));
            break;
          case "RENT-A-CAR":
            object = item.payloadUpdate.products[0];
            parts = object.departureDate.split("-");
            mydate = new Date(parts[0], parts[1] - 1, parts[2]);
            departureDate = this.selectGreaterValue(mydate, new Date(departureDate));
            parts = object.arrivalDate.split("-");
            mydate = new Date(parts[0], parts[1] - 1, parts[2]);
            arrivalDate = this.selectMinValue(mydate, new Date(arrivalDate));
            break;
        }
      });
    }
    if (departureDate.getFullYear() === 1901) {
      departureDate = undefined;
    }
    if (arrivalDate.getFullYear() === 3000) {
      arrivalDate = undefined;
    } //this.getDatesRange(departureDate, arrivalDate) +
    return adults > 0 || children > 0 || nights > 0 || rooms > 0
      ? //' | ' +
        children > 0 || nights > 0 || rooms > 0
        ? (adults > 0 ? adults + (adults > 1 ? " adults, " : " adult, ") : "") +
          (nights > 0 || rooms > 0
            ? (children > 0 ? children + (children > 1 ? " children, " : " child, ") : "") +
              (rooms > 0
                ? (nights > 0 ? nights + (nights > 1 ? " nights, " : " night, ") : "") +
                  (rooms > 0 ? rooms + (rooms > 1 ? " rooms, " : " room. ") : "")
                : nights > 0
                ? nights + (nights > 1 ? " nights. " : " night. ")
                : "")
            : children > 0
            ? children + (children > 1 ? " children. " : " child. ")
            : "")
        : adults > 0
        ? adults + (adults > 1 ? " adults. " : " adult. ")
        : ""
      : ".";
  }
  selectGreaterValue(newValue: any, oldValue: any): any {
    if (newValue > oldValue) {
      return newValue;
    }
    return oldValue;
  }
  selectMinValue(newValue: any, oldValue: any): any {
    if (newValue < oldValue) {
      return newValue;
    }
    return oldValue;
  }

  /**
   *
   * @param itinerary
   */
  // Obtener fecha del viaje
  getDatesRangen(itinerary: any) {
    const destination = itinerary.destination;
    if (destination.length > 0) {
      const arrival = itinerary.arrivalDate
        ? this.datePipe.transform(itinerary.arrivalDate.toString(), "MMM dd, yyyy")
        : this.datePipe.transform(itinerary.arrivalDate, "MMM dd, yyyy");
      const departure = destination.length === 0 ? "" : " to " + this.datePipe.transform(itinerary.departureDate, "MMM dd, yyyy");
      return arrival + departure;
    } else {
      return "Dates not defined";
    }
  }

  // compartiveItineraryCancel(item:any){
  //   console.log('item comparative ->', item);
  //   for (const itinerary of this.itinerary.items) {
  //     console.log('itineary comparative', itinerary);
  //     if (item.id == itinerary.id) {
  //         console.log('itinerary', itinerary);
  //         return itinerary;
  //     }
  //   }
  // }

  destinationsPerItinerary(itinerary: any): string {
    let destinations = "";
    if (itinerary.destination.length > 0) {
      itinerary.destination.forEach((destination, index) => {
        destinations = destinations.concat(
          index === 0
            ? destination.destination_info.cityName
              ? destination.destination_info.cityName
              : destination.iata_code
            : " - " + (destination.destination_info.cityName ? destination.destination_info.cityName : destination.iata_code)
        );
      });
    } else {
      destinations = "Any destination";
    }
    return destinations;
  }
  /**
   *
   * @param itinerary
   */
  // Obtener total price
  getNetPrice(itinerary: any) {
    let price = 0;
    if (itinerary.items.length > 0) {
      itinerary.items.forEach((item) => {
        price += item.optionNightsNetTotal
          ? item.optionNightsNetTotal
          : item.totalPrice
          ? Number.parseInt(item.totalPrice)
          : item.optionTotal
          ? Number.parseInt(item.optionTotal)
          : item.prices
          ? item.prices.total
          : item.netPrice
          ? item.netPrice
          : 0;
      });
    }
    return price;
  }

  /**
   *
   * @param itinerary
   */
  // Obtener los datos del cliente
  getClientData(itinerary: any) {
    const client = itinerary.clients;
    let clientData: any;
    if (client == null) {
      const name = "";
      const email = "";
      const phone = "";
      return "Personal information not available";
    }
    clientData = {
      name: client.first_name !== "false" ? client.first_name + " " + (client.last_name == null ? "" : client.last_name) : "",
      email: (client.email = client.email ? client.email : null),
      phone: client.phone ? client.phone : null,
    };

    return clientData;
  }

  /**
   *
   *  @param itinerary
   */
  // obtener los datos de la agencia
  getAgentData(itinerary: any) {
    let agentData: any;
    agentData = {
      name: "",
      logo: "",
      email: "",
      phone: "",
    };
    this._restService.doGet("app", "agents/" + itinerary.agent_id).subscribe(
      (response: any) => {
        if (response["data"] && response["data"][0]) {
          agentData = {
            name: response["data"][0]["name_agency"],
            logo: response["data"][0]["imagen_logotype"],
            email: response["data"][0]["email"],
            phone: response["data"][0]["phone"],
          };
        }
      },
      (Error) => {
        console.log("Error", Error);
      }
    );
    return agentData;
  }

  /**
   *
   * @param itinerary
   * @param obj
   */
  postSendEmail(itinerary: any, obj: any) {
    var mailOptions = {
      from: "notice@usblick.com", // notice@usblick.com yovannyjvv2@gmail.com
      to: this.getClientData(itinerary).email,
      bcc: "notice@usblick.com", // 'Federico@usblick.com'
      subject: "✈️ Itinerary # " + itinerary.id,
      title: "Agencia",
      body: obj,
    };
    return this._restService.doPost("app", "sendemail", mailOptions);
  }

  /**
   *
   * @param netPrice
   * @param categoryId
   * @param providerId
   */

  getProfitability(netPrice: any, categoryId: any, providerId: any): any {
    let url = "profitabilityCategoryProvider/calculate/" + netPrice + "/" + categoryId + "/" + providerId;
    return this._restService.doPost("app", url, {}).map(
      (response: any) => {
        return response;
      },
      (error) => {
        console.log("Error", error);
        return netPrice + " ";
      }
    );
  }


  // Update detalle de itinerario al momento de cerrar el modal de pago
  emitCloseModalPaymentUpdate() {
    this.emitUpdateItineraryPaymentModal.next();
  }

  public getCategories(): Observable<string[]> {
    let url = 'products/category';
    return this._restService.doGet('app', url)
    .pipe(map(res => res['data']));
  }

  showLoader(): void {
    this.loadingSubject.next(true);
  }

  hideLoader(): void {
    this.loadingSubject.next(false);
  }


  phoneValidator(validators: any): Observable<any> {
    return this._restService.doPost('app', 'validators/phone', validators);
  }


voucherDownload(id: number, clientId: number, voucher: string, qty: number, currencyAgency?: any): void {


      if(this.downloadVoucherInit && voucher === 'only') {
       console.warn('Descarga en proceso');
      return;
    }

    this.downloadVoucherInit = true;

  const headers = new HttpHeaders()
    .set('x-api-user', setting.booking_api_user)
    .set('x-api-key', setting.booking_api_key);

  // Pasar rate y code de la agencia como query params para que el template PHP
  // pueda convertir el voucherValue a la moneda de la agencia (maintest.blade.php).
  const currencyCode = currencyAgency?.code || 'USD';
  const currencyRate = currencyAgency?.rate || 1;
  const url = `${this.urlUsb}downloadVouchers/${id}/${clientId}?currency_code=${encodeURIComponent(currencyCode)}&currency_rate=${currencyRate}`;

        this.notificationService.loading('Descargando voucher...');

  // ✅ Usar HttpClient con responseType: 'blob'
  this.http.get(url, {
    headers: headers,
    responseType: 'blob'
  }).subscribe({
    next: (blob) => {

        this.downloadVoucherInit = false;
        this.notificationService.closeLast();
        this.notificationService.success('Voucher descargado correctamente');

      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = `Voucher_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      this.notificationService.closeLast();
      console.error('Error al descargar:', error);
      this.notificationService?.error('Error al descargar el itinerario');
    }
  });

  }

   itineraryDownload(id: number, clientId: number, type: string): void {

    if(this.downloadItineraryInit) {
      console.warn('Descarga en proceso');
      return;
    }

    this.downloadItineraryInit = true;
  const headers = new HttpHeaders()
    .set('x-api-user', setting.booking_api_user)
    .set('x-api-key', setting.booking_api_key);

  const url = `${this.urlUsb}downloadItinerary/${id}/${clientId}?type=${type}`;

    let messageCharge: string = type === 'quote' ? 'Descargando cotización...' : 'Descargando itinerario...';

      this.notificationService.loading(messageCharge);

  // ✅ Usar HttpClient con responseType: 'blob'
  this.http.get(url, {
    headers: headers,
    responseType: 'blob'
  }).subscribe({
    next: (blob) => {
      this.downloadItineraryInit = false;
      let messageSuccess: string = type === 'quote' ? 'Cotización descargada correctamente' : 'Itinerario descargado correctamente';

       this.notificationService.closeLast(); // Limpiar toast de carga
        this.notificationService.success(messageSuccess);
      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      let messageDownload: string = type === 'quote' ? 'Cotización descargada correctamente' : 'Itinerario descargado correctamente';
      link.download = `${messageDownload}_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      this.notificationService.closeLast();
      console.error('Error al descargar:', error);
      this.notificationService?.error('Error al descargar el itinerario');
    }
  });
}

liquidationDownload(id: number, clientId: number): void {

      if(this.downloadLiquidationInit) {
      console.warn('Descarga en proceso');
      return;
    }

    this.downloadLiquidationInit = true;

  const headers = new HttpHeaders()
    .set('x-api-user', setting.booking_api_user)
    .set('x-api-key', setting.booking_api_key);

  const url = `${this.urlUsb}downloadLiquidations/${id}/${clientId}`;

        this.notificationService.info('Descargando liquidación...');

  // ✅ Usar HttpClient con responseType: 'blob'
  this.http.get(url, {
    headers: headers,
    responseType: 'blob'
  }).subscribe({
    next: (blob) => {

        this.downloadLiquidationInit = false;
        this.notificationService.closeLast(); // Limpiar toast de carga
        this.notificationService.success('Liquidación descargada correctamente');

      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = `liquidación_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      this.notificationService.closeLast();
      console.error('Error al descargar:', error);
      this.notificationService?.error('Error al descargar el itinerario');
    }
  });
}


/**
 * Eliminar opcional agregado en el producto de tours.
 */

removeOptional(optional:any, index:number):void{

  const clientData = JSON.parse(localStorage.getItem(setting.name));
  this.itinerary.clientId = clientData.id;
  // this.itinerary.items[0].serviceExtra.splice(index, 1);
  this.itinerary.items.forEach((tour:any) => {
    if(tour.categoryName == "TOURS"){
      tour.serviceExtra.splice(index, 1);
    }
  });
  this.updateItinerary(this.itinerary);
  this.notificationService.success("¡Felicitaciones! opcional eliminado con éxito.");
}

getFlightsItinerary(id: number): Observable<any> {
  return this._restService.doGet('app', `itinerary/${id}/fly`);
}

toggleInsuranceSelection(insurances: any[]): void {
  const currentSelection = this.selectedInsurancesSubject.value;

  // Verificar si este grupo de insurances ya está seleccionado
  const existingIndex = currentSelection.findIndex(selected =>
    this.areInsurancesEqual(selected, insurances)
  );

  let newSelection: any[];
  if (existingIndex === -1) {
    // Agregar nuevo grupo
    newSelection = [...currentSelection, insurances];
  } else {
    // Remover grupo existente
    newSelection = currentSelection.filter((_, index) => index !== existingIndex);
  }

  this.selectedInsurancesSubject.next(newSelection);
}

// Método para comparar si dos arrays de insurances son iguales
private areInsurancesEqual(insurances1: any[], insurances2: any[]): boolean {
  if (insurances1.length !== insurances2.length) return false;

  // Comparar por el primer planId (asumiendo que todos los planes en el grupo son de la misma marca)
  return insurances1[0]?.plan?.planId === insurances2[0]?.plan?.planId;
}

isInsuranceSelected(insurances: any[]): boolean {
  const currentSelection = this.selectedInsurancesSubject.value;
  return currentSelection.some(selected =>
    this.areInsurancesEqual(selected, insurances)
  );
}

getSelectedInsurances(): any[] {
  return this.selectedInsurancesSubject.value;
}

getSelectedInsuranceCount(): number {
  return this.selectedInsurancesSubject.value.length;
}

clearSelection(): void {
  this.selectedInsurancesSubject.next([]);
}

    /**
   * Validar status si el itinerario esta pagado.
   */
  validateItineraryByStatus(itinerary){
    if(itinerary && itinerary.status_id === 6){
      this.booleanValidateByStatus.next(true);
    } else {
       this.booleanValidateByStatus.next(false);
    }
  }


  emitPaymentUpdate(data: any) {
    this.paymentUpdatebalanceSubject.next(data);
  }


calculateTotal(fieldName: string, actualItinerary: any, currencies: any, currencyAgency: any, type?: string): number {
  try {
    if (!actualItinerary?.items?.length) return 0;

    const agencyRate = parseFloat(currencyAgency?.rate);
    if (agencyRate <= 0) return 0;

    // Crear mapa de tasas para acceso rápido O(1)
    const currencyRates: any = new Map(
      currencies?.map(c => [c.code, parseFloat(c.rate)]) || []
    );

    const total: number = actualItinerary.items
      .filter(item => {
        // Cancelled (5) is always excluded.
        if (item.status_id === 5) return false;
        // Quote flow: include only saved (1), exclude reserved (2) and beyond.
        if (type === 'quote') return item.status_id !== 2;
        // Non-quote flow (e.g. card totals): include saved (1), reserved (2),
        // paid-agency (6), paid-provider (7) and completed (10) so the
        // totals keep showing when the file reaches its final states.
        return [1, 2, 6, 7, 10].includes(item.status_id);
      })
      .reduce((sum, item) => {
        if (item.isPaidAgency || item.isPaidProvider || item.isPendigApprovePay) {

          const historicValue: number = item.converted_amounts?.[fieldName] || item[fieldName] || 0;
          return sum + parseFloat(Number(historicValue).toFixed(2));
        }

        const itemAmount: number = parseFloat(item[fieldName] || 0);
        const itemRate: number = currencyRates.get(item.currency) || 0;

        return itemAmount && itemRate > 0
          ? sum + (itemAmount / (currencyAgency.code === item.currency ? 1 : itemRate)) * (currencyAgency.code === item.currency ? 1 : agencyRate)
          : sum;
      }, 0);

    return parseFloat(total.toFixed(2));

  } catch (error) {
    console.error(`Error en calculateTotal (${fieldName}):`, error);
    return 0;
  }
}

verifiedValuePayloadDestinaiton(payload: any): any {
  const transfers = payload?.transfers;
  const origin = transfers?.pickupLocation;
  const destination = transfers?.dropoffLocation;

  if (!origin || !destination) {
    console.warn('[verifiedValuePayloadDestinaiton] Falta pickupLocation o dropoffLocation:', payload);
    return payload;
  }

  // Payloads viejos no traen rideHailing (campo agregado después): se backfillea
  // igual que providerId -> providersId arriba, para que el resto del flujo
  // pueda asumir siempre el shape nuevo.
  if (transfers.rideHailing === undefined) {
    transfers.rideHailing = false;
  }

  return payload;
}




  // Un guest no pasa por el formulario de itinerary-owner.component.ts
  // (saveFirstItinerary), así que al agregar su primer producto no hay
  // owner ni file todavía. Acá se crean los dos con los datos placeholder
  // que ya trae el guest (mismo "Invitado" que devolvió /guest) — mismo
  // contrato de backend que usa saveFirstItinerary, sin mostrar ningún
  // formulario. Si el itinerario nunca llega a reservarse, lo limpia el
  // mismo proceso que ya limpia cualquier file de agencia sin reserva.
  // No-op para agente real, y para guest que ya tiene itinerario activo.
  async ensureGuestItinerary(): Promise<void> {
    if (!this.userService._isGuest) {
      return;
    }
    if (this.userService.itineraryActive && this.userService.itineraryActive.length > 0) {
      return;
    }

    const fullName = (this.userService._name || 'Invitado').trim().split(' ');
    const first_name = fullName[0] || 'Invitado';
    const last_name = fullName.slice(1).join(' ');

    const data: any = {
      first_name,
      last_name,
      email: this.userService._email || '',
      phone_code: 'Argentina (+54)',
      phone: '00000000',
      itineraryOwner: true,
    };

    const client: any = await this.postDataClient(data).toPromise();
    if (!client?.success) {
      return;
    }

    this._cookieService.put(
      'clientActive',
      `${client.id}||Sr.||${first_name} ${last_name}||${data.email}||${data.phone}||||`
    );

    // No se puede reusar postDataItinerary()/updateItinerary() tal cual: esos
    // solo disparan el POST y siguen (this.itinerary queda sin poblar hasta
    // que forceConsultActiveItinerary() responda en un tick aparte). Si
    // add(item) corriera antes de eso, this.itinerary seguiría null y caería
    // en su propio createItinerary() — un borrador 100% local con id: "",
    // que nunca llega al backend. Acá se espera la cadena real: crear en
    // backend, y recién devolver cuando this.itinerary/itineraryActive
    // tienen el itinerario real, con id.
    const clientSystem = JSON.parse(localStorage.getItem(setting.name) || 'null');
    const itineraryPayload: any = {};
    itineraryPayload.client_id = client.id;
    itineraryPayload.title = 'Reserva';
    itineraryPayload.clientId = clientSystem?.id;
    itineraryPayload.status = 'Saved';
    itineraryPayload.uid = this.randomNumber(1, 100000);
    itineraryPayload.agent_id = this.userService._agentID;
    itineraryPayload.agency_id = this.userService._agencyID;
    itineraryPayload.status_id = '1';
    itineraryPayload.location = null;
    itineraryPayload.origin = null;
    itineraryPayload.arrivalDate = null;
    itineraryPayload.departureDate = null;
    itineraryPayload.currency = null;
    itineraryPayload.active = 1;
    itineraryPayload.data = null;

    const createResponse: any = await this._restService.doPost('app', 'itineraries', itineraryPayload).toPromise();
    if (!createResponse?.success) {
      return;
    }

    const activeResponse: any = await this._restService
      .doGet('app', `itineraries?active_agent_id=${this.userService._agentID}&active=1`)
      .toPromise();

    if (activeResponse?.data && Object.keys(activeResponse.data).length > 0) {
      activeResponse.data[1] = activeResponse.data[0].clients;
      this.itinerary = activeResponse.data[0];
      this.sendMessageActiveItinerary(activeResponse.data);
    }
  }




}
